import { useState, useEffect } from "react";

/**
 * A custom hook that debounces a value with a specified delay
 * @param value The value to debounce
 * @param delay The delay in milliseconds (default: 500ms)
 * @returns The debounced value
 */
function useDebounce<T>(value: T, delay: number = 500): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value);

	useEffect(() => {
		// Set up the timeout to update the debounced value
		const timer = setTimeout(() => {
			setDebouncedValue(value);
		}, delay);

		// Clean up the timeout if the value changes before the delay has passed
		return () => {
			clearTimeout(timer);
		};
	}, [value, delay]);

	return debouncedValue;
}

export default useDebounce;
